import { FC } from "react";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import AnalysisChartCard from "./ChartCard";

interface ChartData {
  name: string;
  value: number;
}

interface CustomLineChartProps {
  data: ChartData[];
}

export const FinancialTrendLineChart: FC<CustomLineChartProps> = ({ data }) => {
  return (
    <AnalysisChartCard headerTitle="Financial Trend">
      <ResponsiveContainer width="100%" height="80%">
        <AreaChart
          data={data}
          margin={{ top: 20, right: 30, left: 0, bottom: 0 }}
        >
          <defs>
            <linearGradient id="colorValue" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#3b82f6" stopOpacity={0.2} />
              <stop offset="95%" stopColor="#3b82f6" stopOpacity={0} />
            </linearGradient>
          </defs>

          <CartesianGrid
            strokeDasharray="3 3"
            vertical={false}
            stroke="#d1d5db"
          />

          <XAxis
            dataKey="name"
            tick={{ fill: "#6b7280", fontSize: 12 }}
            axisLine={false}
            tickLine={false}
          />
          <YAxis
            tick={{
              fill: "#6b7280",
              fontSize: 12,
              color: "#4F4F4F",
              fontWeight: "700",
            }}
            axisLine={false}
            tickLine={false}
            domain={[20, 110]}
            tickFormatter={(value) => `$${value}`}
          />
          <Tooltip
            cursor={{ stroke: "#3b82f6", strokeWidth: 2 }}
            contentStyle={{
              backgroundColor: "white",
              borderRadius: "0.5rem",
              border: "1px solid #d1d5db",
              fontSize: "0.875rem",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
            }}
          />

          <Area
            type="linear"
            dataKey="value"
            stroke="#4379EE"
            fillOpacity={1}
            fill="url(#colorValue)"
            strokeWidth={2}
            dot={(props) => (
              <g>
                <circle
                  cx={props.cx}
                  cy={props.cy}
                  r={12}
                  fill="#1d4ed8"
                  opacity={0.2}
                >
                  <animate
                    attributeName="r"
                    from="10"
                    to="20"
                    dur="1.5s"
                    repeatCount="indefinite"
                    begin="0s"
                    values="10;20;10"
                    keyTimes="0;0.5;1"
                    keySplines="0.4 0 0.2 1;0.4 0 0.2 1"
                    calcMode="spline"
                  />
                  <animate
                    attributeName="opacity"
                    values="0.2;0;0.2"
                    dur="1.5s"
                    repeatCount="indefinite"
                  />
                </circle>
                <circle
                  cx={props.cx}
                  cy={props.cy}
                  r={5}
                  stroke="#1d4ed8"
                  strokeWidth={2}
                  fill="white"
                />
              </g>
            )}
            activeDot={{
              r: 6,
              fill: "#1d4ed8",
              stroke: "white",
              strokeWidth: 2,
            }}
          />
        </AreaChart>
      </ResponsiveContainer>
    </AnalysisChartCard>
  );
};
